import { render, staticRenderFns } from "./alignControl.vue?vue&type=template&id=41cd7574&"
import script from "./alignControl.vue?vue&type=script&lang=ts&"
export * from "./alignControl.vue?vue&type=script&lang=ts&"
import style0 from "./alignControl.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports